const body = document.body;
const searchContainer = document.getElementById("mobile-search-container-js");
const searchInput = document.getElementById("search-input-js");
const desktopSearchInput = document.getElementById("desktop-search-input-js");
const desktopSearchContainer = document.getElementById("desktop-search-container-js");
const closeButton = document.getElementById("search-input-close-js");
const viewportHeight = window.innerHeight;
const desktopSearchResultsContainer = document.getElementById("desktop-live-search-container");
const mobileSearchResultsContainer = document.getElementById("mobile-live-search-container");
const objectList = document.getElementById("mobile-live-search-list-js");
const deskTopObjectList = document.getElementById("desktop-live-search-list-js");

searchInput.addEventListener("focus", function () {
  window.scrollTo(0, 0);
  body.classList.add("window-hidden");
  searchContainer.classList.add("search-input--active");
  mobileSearchResultsContainer.style.cssText = `height: ${
    viewportHeight - mobileSearchResultsContainer.offsetTop
  }px;`;
});

closeButton.addEventListener("click", function () {
  closeSearch();
});

const closeSearch = () => {
  body.classList.remove("window-hidden");
  searchContainer.classList.remove("search-input--active");
  mobileSearchResultsContainer.style.cssText = ``;
};

searchInput.addEventListener("input", function (evt) {
  searchEvent(evt.target.value, "mobile");
});

desktopSearchInput.addEventListener("input", function (evt) {
  searchEvent(evt.target.value, "desktop");
});

// desktopSearchContainer.addEventListener("blur", function (evt) {
//   desktopSearchInput.value = '';
//   deskTopObjectList.innerHTML = '';
// });

document.body.addEventListener("click", (e) => {
  if (!e.target.closest("#desktop-search-container-js")) {
    desktopSearchInput.value = "";
    deskTopObjectList.innerHTML = "";
  }
});

const searchEvent = (eventValue, screenMode) => {
  const searchValue = eventValue.replace(/\s/g, "+");
  const fetchQuery = `/search/suggest.json?q=${searchValue}&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=last`;

  fetch(fetchQuery)
    .then((response) => response.json())
    .then((suggestions) => {
      
      const productSuggestions = suggestions.resources.results.products;
      const parentElement = document.createElement("div");
      
      if (productSuggestions.length === 0) {
        return createNoProductFound(screenMode);
      }

      productSuggestions.map((suggestion) => {
        const productElement = createProductElement(
          suggestion.title,
          suggestion.price,
          suggestion.image,
          suggestion.url
        );
        parentElement.appendChild(productElement);
      });

      switch (screenMode) {
        case "mobile": {
          objectList.innerHTML = "";
          objectList.appendChild(parentElement);
          document.getElementById("view-all-btn-js").href = `/search?q=${searchValue}`;
          break;
        }
        case "desktop": {
          deskTopObjectList.innerHTML = "";
          deskTopObjectList.appendChild(parentElement);
          break;
        }
      }
    });
};

const createProductElement = (title, price, imageSrc, productLink) => {
  const outerDiv = document.createElement("a");
  const imageElement = document.createElement("img");
  const innerDiv = document.createElement("div");
  const productTitle = document.createElement("p");
  const productPrice = document.createElement("p");

  outerDiv.classList.add("search--result");
  productTitle.classList.add("search--result-product-title");
  productPrice.classList.add("search--result-product-price");

  imageElement.src = imageSrc;
  imageElement.alt = title;
  outerDiv.href = productLink;
  outerDiv.alt = title;
  productTitle.innerHTML = `${title.substring(0, 75)}${
    title.length > 75 ? "..." : ""
  }`;
  productPrice.innerHTML = `£${price}`;

  outerDiv.appendChild(imageElement);
  innerDiv.appendChild(productTitle);
  innerDiv.appendChild(productPrice);
  outerDiv.appendChild(innerDiv);

  return outerDiv;
};

const createNoProductFound = (screenMode) => {
  const noProductDiv = document.createElement("div");
  noProductDiv.classList.add("search--result");
  noProductDiv.classList.add("no-result");
  noProductDiv.innerHTML = "No products found";

  switch (screenMode) {
    case "mobile": {
      objectList.innerHTML = "";
      objectList.appendChild(noProductDiv);
      break;
    }
    case "desktop": {
      deskTopObjectList.innerHTML = "";
      deskTopObjectList.appendChild(noProductDiv);
      break;
    }
  }
};
